import React from "react";
import { DataGrid, GridColDef, GridRowSelectionModel } from "@mui/x-data-grid";
import { parseDate } from "../../helpers/parser";
import { Link } from "react-router-dom";
import styled from "styled-components";

type TableProps = {
  events: InfoEvent[];
  setSelection: (selection: InfoEvent[]) => void;
};

const StyledLink = styled(Link)`
  text-decoration: none;
`;

const columns: GridColDef<InfoEvent>[] = [
  {
    field: "date",
    headerName: "Dato",
    width: 200,
    renderCell: (params) => (
      <StyledLink to={`/events/${params.row.id}`}>
        {parseDate(params.row.date, "LLL")}
      </StyledLink>
    ),
  },
  {
    field: "location",
    headerName: "Sted",
    width: 150,
    renderCell: (params) => (
      <StyledLink to={`/events/${params.row.id}`}>{params.row.location}</StyledLink>
    ),
  },
  {
    field: "isPublic",
    headerName: "Offentliggjort",
    width: 150,
    type: "boolean",
  },
  {
    field: "completed",
    headerName: "Afviklet",
    type: "boolean",
    width: 150,
  },
];

const EventsTable: React.FC<TableProps> = React.memo(({ events, setSelection }) => {
  const handleSelectionChange = (newSelectionModel: GridRowSelectionModel) => {
    const selectedIds = new Set(newSelectionModel.map(String));
    setSelection(events.filter((row) => selectedIds.has(row.id)));
  };

  return (
    <div style={{ width: "100%", minHeight: 400, background: "white" }}>
      <DataGrid
        rows={events}
        columns={columns}
        pageSizeOptions={[10, 20, 50]}
        checkboxSelection
        onRowSelectionModelChange={handleSelectionChange}
      />
    </div>
  );
});

export default EventsTable;
